import axios from "axios";
import i18next from 'i18next';

import {store} from "../configureStore";
import {
    botsReloadBot
} from '../actions/Dashboard'
import {renderErrorsAsString} from "../Components/utils";
import {toast} from "react-toastify";
import {ajax} from "rxjs/ajax";
import {shopsSetSimpleChat} from "../actions/Shops";
import {
    personalInfoStart,
    personalInfoSuccess,
    personalInfoFail,
} from "../actions/Auth";




export function setSimpleChat(changeTo) {
     return function (dispatch) {
         const instance = axios.create({
             baseURL: process.env.REACT_APP_API_URL,
             timeout: 30000,
             headers: {
                 Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                 'Content-Type': 'application/json',
             },
         });

         return instance.patch(`shop/shops/${store.getState().Shops.activeShop.id}/`,{'simple_chat':changeTo}).then(({data}) => {
             dispatch(shopsSetSimpleChat(changeTo))
             return data;
         },err=>{
             return err;
         })
     }
}

export function getPersonalInfo() {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(personalInfoStart());

        return instance.get(`operators/operators/undefined/get_profile/`).then(({data}) => {
            if (data.status === 'ok') {
                dispatch(personalInfoSuccess(data.result));
            } else {
                dispatch(personalInfoFail(data.errors));
            }
        }, err => {
            dispatch(personalInfoFail(err));
        })
    }
}

export function updateAvatar(avatar_url, callback) {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        return instance.post(`operators/operators/undefined/update_avatar_url/`, {avatar_url}).then(({data}) => {
            if (data.status === 'ok') {
                toast.success(data.status);
                callback && callback();
            }
        }, err => {
            toast.error(i18next.t('errors.common.request_sent', 'Error sending request'));
        })
    }
}